function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M92.1 35.4h14.2v35.4H92.1V35.4zm0 78h14.2v70.9H92.1v-70.9zM63.8 255.1h155.9v28.3H63.8v-28.3zM49.6 0v248h184.3V0H49.6zM78 219.7V106.3h127.5v113.4H78zM205.5 78H78V28.4h127.5V78z"
})));